<i18n lang="yaml">
  pt:
    empty: "Não encontramos nenhum projeto."
</i18n>

<template>
  <div class="cardlist p-relative">
    <div
      class="cardlist__wrapper wrapper row grid--center"
    >
      <template v-if="!isLoading">
        <AsyncCard
          v-for="app in apps.list"
          v-show="!$refs?.page?.loading"
          :key="app.id"
          :app="app"
          :dash-type="dashType"
        />
      </template>

      <template v-else>
        <AsyncSkeleton
          v-for="(app, index) in 6"
          :key="index"
        />
      </template>

      <small
        v-show="!isLoading && ($refs?.page?.list || []).length <= 0"
        class="empty"
        data-grid="center-center"
      >
        {{ $t("empty") }}
      </small>
    </div>

    <AsyncPagination
      ref="page"
      action="apps/searchApps"
      getter="apps/getApps"
      filter="apps"
      :per-page="6"
      :rules="rules"
      @loading="state => setLoading(state)"
    />
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'
import { mapGetters } from 'vuex'

const AsyncCard = defineAsyncComponent(() => import('../card'))
const AsyncSkeleton = defineAsyncComponent(() => import('../../../global/Skeleton'))
const AsyncPagination = defineAsyncComponent(() => import('../../../global/Pagination'))

export default defineComponent({
  name: 'CardList',

  components: {
    AsyncCard,
    AsyncSkeleton,
    AsyncPagination
  },

  props: {
    dashType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      apps: 'apps/getApps'
    }),

    rules: () => ({
      query: 'min:3',
      status: 'in:0,1'
    })
  },

  methods: {
    setLoading (state) {
      this.isLoading = state
    }
  }
})
</script>

<style lang="scss" scoped>
  .cardlist {
    margin: -3.5rem 0 0;

    &__wrapper {
      gap: 42px 24px;
    }

    .empty,
    .loading-container {
      margin-top: 35px;
      min-height: 300px;
    }

    .empty {
      font-size: 1.4rem;
      color: rgb(var(--gray1));
    }

    .global-pagination {
      margin-top: 40px;
    }

    .skeleton {
      border-radius: 10px;
      aspect-ratio: 1 / .75;
      width: min(100%, 384px);
    }
  }
</style>
